module.exports = __webpack_public_path__ + "img/daichao1.407792c8.png";